export enum BadgeImageType {
  Logo = 'Logo',
  QRCode = 'QRCode',
  Picture = 'Picture',
}
